import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { deleteOrganizationSetting as deleteOrganizationSettingService } from '../../../services/organization/OrganizationService';

interface Values {
  isLoading: boolean;
  deleteOrganizationSetting: (organizationId: string, settingId: string) => Promise<number>;
}

const useDeleteOrganizationSetting = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteOrganizationSetting = async (organizationId: string, settingId: string): Promise<number> => {
    try {
      setIsLoading(true);

      const result = await deleteOrganizationSettingService(organizationId, settingId);
      setIsLoading(false);
      return result.data;
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return 0;
    }
  };

  return { deleteOrganizationSetting, isLoading };
};

export default useDeleteOrganizationSetting;
